module.exports = __webpack_public_path__ + "assets/img/detail-content-img-1-4eb7de88.jpg";